import React from "react";

import "./../../css/thumbnail.css";

const LANDSCAPE_VIEW = "landscape";
const PORTRAIT_VIEW = "portrait";

export class ThumbnailComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            imageClass: LANDSCAPE_VIEW,  // default
            imageSrc: require("./../../images/" + this.props.category + "/" + this.props.photo.name + ".jpg"),
            imageLoaded: false,
            image: new Image()
        }

        this.handleImageOnLoad = this.handleImageOnLoad.bind(this);
        this.handleImageClick = this.handleImageClick.bind(this);
        this.disableContextMenu = this.disableContextMenu.bind(this);
    }

    componentWillMount() {
        const that = this;
        this.state.image.onload = function() {
            that.handleImageOnLoad(that.state.image);
        }
        this.state.image.src = this.state.imageSrc;

        if (this.state.image.complete) {
            this.handleImageOnLoad(this.state.image);
        }
    }

    handleImageOnLoad(img) {
        const height = img.height || 0;
        const width  = img.width || 0;

        if (height > width) {
            this.setState({
                imageClass: PORTRAIT_VIEW
            });
        }
        this.setState({
            imageLoaded: true
        });
    }

    disableContextMenu(event) {
        event.preventDefault();
    }

    // handleImageOnLoad({target:img}) {
    //     const height = img.height || 0;
    //     const width  = img.width || 0;
    //
    //     if (height > width) {
    //         this.setState({
    //             imageClass: PORTRAIT_VIEW
    //         });
    //     }
    //     this.setState({
    //         imageLoaded: true
    //     });
    // }

    handleImageClick() {
        if (this.state.imageLoaded) {
            this.props.imageClick(this.props.index);
        }
    }

    render() {
        let loading = "";

        if (!this.state.imageLoaded) {
            let loadingImageSrc = require("./../../images/loading.svg");
            loading = <div className="loading"><img src={loadingImageSrc} alt="" /></div>;
        }

        return (
            <div className="thumbnail-component" onContextMenu={this.disableContextMenu}>
                {loading}
                <img src={this.state.imageSrc} className={this.state.imageClass} alt="" onClick={this.handleImageClick} />
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/widgets/Common/ThumbnailComponent.js